// extracted by mini-css-extract-plugin
module.exports = {"card":"eventCard-module--card--20u8p","img":"eventCard-module--img--1aImu","icon":"eventCard-module--icon--MHZtC","link":"eventCard-module--link--3ODQI"};